import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/winter-camp/Index.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/winter-camp',
  name: 'activity_winter_camp',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '霹雳熊·绳冬令营',
  },
}

export default [indexRoute]
